























































































import Vue from "vue"
import CMobileSearchKit, {
  SearchParams,
  JobCategoryOption,
  NormalOption,
  AgeOption,
  SearchResult,
} from "./local/CMobileSearchKit.vue"
import CPcSearchKit from "./local/CPcSearchKit.vue"
import PFullFunctionIntroductionModal from "./local/PFullFunctionIntroductionModal.vue"
import CProfileList, {
  ImpressedEmitArgument,
  ToggleFavoriteStatusEmitArgument,
} from "./CProfileList.vue"
import {
  UniversalReadAcl,
  ParticularReadAcl,
} from "~/config/acl/accessControlList"
import Container, {
  EmitArgumentOfScroll,
} from "~/components/guideline/frame/Container.vue"
import CSignUpStaticAlert from "~/components/custom/alert/CSignUpStaticAlert.vue"
import { UserProfileSearchResultView } from "~/backendApis/viewModel"
import CInquirySignUpFloatingButtonGroup from "~/components/custom/buttonGroup/CInquirySignUpFloatingButtonGroup.vue"
import { queryParameterUiLogics } from "~/uiLogics/queryParameter"
import CShouldApealPaidPlanAlert from "~/components/custom/alert/CShouldApealPaidPlanAlert.vue"

export default Vue.extend({
  components: {
    Container,
    CProfileList,
    CSignUpStaticAlert,
    CMobileSearchKit,
    CPcSearchKit,
    CInquirySignUpFloatingButtonGroup,
    PFullFunctionIntroductionModal,
    CShouldApealPaidPlanAlert,
  },
  data() {
    return {
      isShownFullFunctionIntroductionModal: false,
      isShownShouldApealPaidPlanContract: false,
    }
  },
  computed: {
    favoriteUniversalUids(): string[] {
      return this.$clAuth.corporationId
        ? this.$clStores.corporationSideFavoriteUserList.getters.idList
        : []
    },
    isFullParameterSearch(): boolean {
      return this.$clAuth.hasPermission(
        ParticularReadAcl.FULL_PARAMETER_USER_PROFILE_SEARCH
      )
    },
    isAccessibleRequireAuthenticationResources(): boolean {
      return this.$clAuth.hasPermission(
        UniversalReadAcl.REQUIRE_AUTHENTICATION_RESOURCES
      )
    },
    jobCategoryOptions(): JobCategoryOption[] {
      return this.$clStores.profileSearchParameterOption.getters
        .jobCategoryOptions
    },
    availableUptimeOptions(): NormalOption[] {
      return this.$clStores.profileSearchParameterOption.getters
        .availableUptimeOptions
    },
    sinceLastAccessDaysOptions(): NormalOption[] {
      return this.$clStores.profileSearchParameterOption.getters
        .sinceLastAccessDaysOptions
    },
    prefectureOptions(): NormalOption[] {
      return this.$clStores.profileSearchParameterOption.getters
        .prefectureOptions
    },
    workingFormOptions(): NormalOption[] {
      return this.$clStores.profileSearchParameterOption.getters
        .workingFormOptions
    },
    ageOptions(): AgeOption[] {
      return this.$clStores.profileSearchParameterOption.getters.ageOptions
    },
    defaultOffsetTop(): number {
      const path = this.$route.path
      return this.$clStores.scrollPosition.getters.getOffsetTop(path)
    },
    searchedUserProfiles(): UserProfileSearchResultView[] {
      return this.$clStores.profileSearchList.getters.profiles
    },
    searchParams: {
      get(): SearchParams {
        return this.$clStores.profileSearchList.getters.searchParams
      },
      set(newParams: SearchParams): void {
        this.$clStores.profileSearchList.actions.updateSearchParams(newParams)
      },
    },
    canFetchNextPage(): boolean {
      return this.$clStores.profileSearchList.getters.canFetchNextPage
    },
    hasAnySearchParams(): boolean {
      return this.$clStores.profileSearchList.getters.hasAnySearchParams
    },
    searchResult(): SearchResult | null {
      return this.$clStores.profileSearchList.getters.searchResult
    },
    shouldApealPaidPlanContract(): boolean {
      return this.$clStores.corporationContractAppeal.getters
        .shouldApealPaidPlanContract
    },
  },
  watch: {
    "$clAuth.finishedAuthProcess": {
      handler(isFinishedAuthProcess) {
        if (!isFinishedAuthProcess) {
          return
        }

        if (this.$clStores.profileSearchList.getters.exists) {
          this.updateUrlQueryParameter()
        } else {
          this.initializeProfileListResource()
        }

        this.$clStores.profileSearchParameterOption.actions.loadParameter(
          this.isFullParameterSearch
        )

        if (this.$clAuth.corporationId) {
          this.$clStores.corporationContractAppeal.actions.refresh()
        }
      },
      immediate: true,
    },
  },
  methods: {
    goToContactForm() {
      window.open(
        "https://crowdlinks.jp/client/form/contact/?from=scout_modal",
        "_blank"
      )
    },
    openFullFunctionIntroductionModal() {
      this.isShownFullFunctionIntroductionModal = true
    },
    closeFullFunctionIntroductionModal() {
      this.isShownFullFunctionIntroductionModal = false
    },
    logImpressions({ impressions }: ImpressedEmitArgument) {
      // 企業アカウントに切り替えている場合のみ、インプレッションを記録する。
      if (this.$clAuth.corporationId) {
        this.$clStores.profileSearchImpressionEvent.actions.logAllImpressions(
          impressions
        )
      }
    },
    async initializeProfileListResource() {
      const {
        searchWord,
        smallJobCategoryIds,
        availableUptimeIds,
        sinceLastAccessDays,
        prefectureIds,
        workingFormId,
        minAge,
        maxAge,
      } = this.$route.query

      if (
        searchWord ||
        smallJobCategoryIds ||
        availableUptimeIds ||
        prefectureIds ||
        sinceLastAccessDays ||
        workingFormId ||
        minAge ||
        maxAge
      ) {
        this.$clStores.profileSearchList.actions.updateSearchParams({
          searchWord: searchWord ? String(searchWord) : "",
          smallJobCategoryIds: smallJobCategoryIds
            ? Array.isArray(smallJobCategoryIds)
              ? smallJobCategoryIds.map((q) => Number(q))
              : [Number(smallJobCategoryIds)]
            : [],
          availableUptimeIds: availableUptimeIds
            ? Array.isArray(availableUptimeIds)
              ? availableUptimeIds.map((q) => Number(q))
              : [Number(availableUptimeIds)]
            : [],
          sinceLastAccessDays: sinceLastAccessDays
            ? Number(sinceLastAccessDays)
            : null,
          prefectureIds: prefectureIds
            ? Array.isArray(prefectureIds)
              ? prefectureIds.map((q) => Number(q))
              : [Number(prefectureIds)]
            : [],
          workingFormId: workingFormId ? Number(workingFormId) : undefined,
          /**
           * 年齢は５歳刻みでしか指定できない仕様なので、5で割り切れない値が設定されている場合はnullとする。
           * この指定がないとAPI通信で不正リクエストとして例外が発生する。
           */
          minAge: minAge && Number(minAge) % 5 === 0 ? Number(minAge) : null,
          maxAge: maxAge && Number(maxAge) % 5 === 0 ? Number(maxAge) : null,
        })
      }

      await Promise.all([
        this.fetchNewProfiles(),
        this.$clAuth.corporationId
          ? this.$clStores.corporationSideFavoriteUserList.actions.refreshList()
          : null,
      ])
    },
    toggleFavoriteStatus({ universalUid }: ToggleFavoriteStatusEmitArgument) {
      this.$clStores.corporationSideFavoriteUserList.actions.toggleFavoriteStatus(
        universalUid
      )
    },
    handleClickScoutButton(universalUid: string) {
      this.$emit("click-scout-button", universalUid)
    },
    updateOffsetOfPage({ offsetTop }: EmitArgumentOfScroll) {
      this.$clStores.scrollPosition.actions.setOffsetTop({
        path: this.$route.path,
        offsetTop,
      })
    },
    /**
     * 新しい検索条件でプロフィールを検索をする。
     */
    fetchNewProfiles() {
      this.$clStores.profileSearchList.actions.fetchNew()
      this.$clStores.profileSearchImpressionEvent.actions.reset()
      this.updateUrlQueryParameter()
      window.scrollTo(0, 0)
    },
    /**
     * 現在の検索条件のまま次のページの情報を取得する。
     */
    fetchNextPage() {
      this.$clStores.profileSearchList.actions.fetchNextPage()
    },
    updateUrlQueryParameter() {
      queryParameterUiLogics().updateURLQuery({
        searchWord: this.searchParams.searchWord,
        smallJobCategoryIds: this.searchParams.smallJobCategoryIds,
        availableUptimeIds: this.searchParams.availableUptimeIds,
        sinceLastAccessDays: this.searchParams.sinceLastAccessDays,
        prefectureIds: this.searchParams.prefectureIds,
        workingFormId: this.isFullParameterSearch
          ? this.searchParams.workingFormId
          : undefined,
        minAge: this.searchParams.minAge,
        maxAge: this.searchParams.maxAge,
      })
    },
    updateIsShownShouldApealPaidPlanContract() {
      this.isShownShouldApealPaidPlanContract = !this
        .isShownShouldApealPaidPlanContract
    },
  },
})
